import { environment_dev } from "./environment.dev";
import { environment_prod } from "./environment.prod";

export const environment =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development" ? environment_dev : environment_prod;
